import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const WithSwiper = (Component) => {
  return ({ slides, swiperConfig, swiperRef, ...props }) => (
    <Swiper
      ref={swiperRef}
      slidesPerView={swiperConfig.slidesPerView}
      spaceBetween={swiperConfig.spaceBetween}
      breakpoints={swiperConfig.breakpoints}
      grabCursor={true}
      pagination={{
        el: ".swiper-pagination",
        clickable: false,
        renderBullet: (_index, className) =>
          `<span class="${className}"></span>`,
        type: "bullets",
        bulletActiveClass: "swiper-pagination-bullet-active",
        dynamicBullets: true,
        dynamicMainBullets: 3,
      }}
      navigation={{
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
        clickable: true,
      }}
      modules={[Pagination, Navigation]}
      className="swiper_container property-grid"
      {...props}
    >
      {slides.map((slide, index) => (
        <SwiperSlide key={index}>{slide}</SwiperSlide>
      ))}
    </Swiper>
  );
};

export default WithSwiper;
